import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class WorkService {
    constructor(private dataTask: DataTaskService) {}

    public async getEdit(params: WorkEditParams): Promise<WorkEdit> {
        return (await this.dataTask.Post(1341, params))[0];
    }

    public listLinkTypes(): Promise<WorkLinkType[]> {
        return this.dataTask.Post(2063);
    }

    public listOperations(params: WorkOperationsParams): Promise<WorkOperationItem[]> {
        return this.dataTask.Post(3902, params);
    }

    public changeOperation(params: WorkOperationParams): Promise<WorkOperationChange[]> {
        return this.dataTask.Post(2650, params);
    }

    public async saveObj(page: WorkEdit): Promise<WorkResponse> {
        return (await this.dataTask.Post(1342, page))[0];
    }

    public async deleteItem(params: WorkDeleteParams): Promise<WorkResponse> {
        return (await this.dataTask.Post(1354, params))[0];
    }
}

export interface WorkEditParams {
    prod_id: string | number;
    work_keyno: string | number;
}

export interface WorkOperationsParams {
    direct: '1';
    factory_id: string;
}

export interface WorkOperationParams {
    factory_id: string;
    operation_id: string;
}

export interface WorkDeleteParams {
    work_keyno: string;
}

export interface WorkLinkType {
    link_linktype: string;
    link_linktype_name: string;
}

export interface WorkOperationItem {
    item_id: string;
    item_name: string;
    orderby: string;
}

export interface WorkOperationChange {
    workgrp_keyno?: string;
    equipment_id?: string;
}

export interface WorkResponse {
    errorcode: string;
    errormessage: string;
}

export type WorkValue = string | number | boolean | null | undefined;

export type WorkNumber = string | number;

export interface WorkEdit extends WorkEditParams {
    work_keyno: string;
    businessco_no: string;
    businessco_companyname: string;
    page_heading: string;
    factory_id: string;
    operation_id: string;
    workgrp_keyno: string;
    show_workgrp_keyno: '0' | '1';
    equipment_id: string;
    use_suboperations: '0' | '1';
    quantity_from_suboperations: '0' | '1';
    quantity: WorkNumber;
    unit_no: string;
    methoddescription: string;
    operation_order: WorkNumber;
    link_linktype: string;
    link_delay_hours: WorkNumber;
    adjustment_unit_name: string;
    adjustment_pre: WorkNumber;
    adjustment_post: WorkNumber;
    show_setting: '0' | '1';
    view_id: string;
    p2_datatask_keyno: string;
    records?: WorkSaveRecord[];
    [key: string]: WorkValue | WorkSaveRecord[];
}

export interface WorkSaveRecord {
    suboperation_keyno: string;
    quantity: WorkValue;
    quantity_in_work_units: WorkValue;
    time_adjust_factor: WorkValue;
    adjusted_quantity_in_work_units: WorkValue;
}

export interface WorkSuboperationRow {
    suboperation_keyno: string;
    quantity: WorkValue;
    quantity_multiplied_by_std_time: WorkValue;
    quantity_in_work_units: WorkValue;
    time_adjust_factor: WorkValue;
    adjusted_quantity_in_work_units: WorkValue;
    std_time: WorkValue;
    std_time_in_work_units: WorkValue;
    _dirty?: boolean;
    [key: string]: WorkValue;
}
